import { CheckSquare } from 'lucide-react'
import { CATEGORY_META, SEVERITY_META } from '../config'
import type { AnnouncementCategory, AnnouncementSeverity } from '../types'

/** Category badge — icon + label on a soft accent tint. Never colour-only. */
export function CategoryBadge({ category }: { category: AnnouncementCategory }) {
  const meta = CATEGORY_META[category]
  if (!meta) return null
  const { Icon, label, accent, accentSoft } = meta
  return (
    <span className="anc-cat-badge" style={{ color: accent, background: accentSoft }}>
      <Icon size={12} aria-hidden="true" />
      {label}
    </span>
  )
}

/** Severity pill — coloured dot + label. Never colour-only. */
export function SeverityPill({ severity }: { severity: AnnouncementSeverity }) {
  const meta = SEVERITY_META[severity]
  if (!meta) return null
  return (
    <span className="anc-sev-pill" style={{ color: meta.color, background: meta.softBg }}>
      <span className="anc-sev-dot" style={{ background: meta.color }} aria-hidden="true" />
      {meta.label}
    </span>
  )
}

/** Mandatory-acknowledgment pill. Shows "Acknowledged" once the user has
 *  acknowledged; otherwise "Action required". */
export function MandatoryPill({ acknowledged }: { acknowledged?: boolean }) {
  return (
    <span className={`anc-mand-pill${acknowledged ? ' anc-mand-pill--done' : ''}`}>
      <CheckSquare size={11} aria-hidden="true" />
      {acknowledged ? 'Acknowledged' : 'Action required'}
    </span>
  )
}
